// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2PoiC","empty":"ModalGraph_empty__1JT6W"};